import { Link, Outlet } from "react-router-dom"

import logo from "../../assets/go-logo.svg"

import styled from "styled-components"

const trustSignals = [
   { icon: "✓", text: "Verified Partners" },
   { icon: "◉", text: "Real-Time Tracking" },
   { icon: "⬡", text: "Secure Payments" },
]

const AuthContainer = () => {
   return (
      <Wrapper>
         <BrandPanel>
            <BrandContent>
               <Illustration src="/preview.png" alt="GoTruck - Move cargo across Nigeria" />
               <BrandHeadline>Move Cargo Across Nigeria with Reliability &amp; Speed</BrandHeadline>
               <TrustSignals>
                  {trustSignals.map((item) => (
                     <TrustItem key={item.text}>
                        <TrustIcon>{item.icon}</TrustIcon>
                        <span>{item.text}</span>
                     </TrustItem>
                  ))}
               </TrustSignals>
            </BrandContent>
         </BrandPanel>

         <FormPanel>
            <FormPanelInner>
               <LogoHeader>
                  <Link to="/">
                     <img src={logo} alt="GoTruck" />
                  </Link>
               </LogoHeader>
               <FormContent>
                  <Outlet />
               </FormContent>
            </FormPanelInner>
         </FormPanel>
      </Wrapper>
   )
}

const Wrapper = styled.div`
   display: flex;
   min-height: 100vh;

   @media (max-width: 768px) {
      flex-direction: column;
   }
`

const BrandPanel = styled.div`
   width: 45%;
   background: #ffffff;
   display: flex;
   align-items: center;
   justify-content: center;
   position: sticky;
   top: 0;
   height: 100vh;
   overflow: hidden;

   @media (max-width: 768px) {
      display: none;
   }
`

const BrandContent = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   padding: 40px;
   text-align: center;
`

const Illustration = styled.img`
   width: 100%;
   max-width: 420px;
   height: auto;
   margin-bottom: 32px;
   object-fit: contain;
`

const BrandHeadline = styled.h1`
   color: #1d2939;
   font-size: 24px;
   font-weight: 700;
   line-height: 1.35;
   margin-bottom: 40px;
   max-width: 340px;
`

const TrustSignals = styled.div`
   display: flex;
   gap: 28px;
`

const TrustItem = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   gap: 8px;
   color: #475467;
   font-size: 13px;
   font-weight: 500;
`

const TrustIcon = styled.div`
   width: 40px;
   height: 40px;
   border-radius: 50%;
   background: rgba(226, 118, 38, 0.12);
   display: flex;
   align-items: center;
   justify-content: center;
   font-size: 18px;
   color: #e27626;
`

const FormPanel = styled.div`
   flex: 1;
   background: #fff;
   display: flex;
   align-items: center;
   justify-content: center;
   min-height: 100vh;
   overflow-y: auto;

   @media (max-width: 768px) {
      min-height: 100vh;
   }
`

const FormPanelInner = styled.div`
   width: 100%;
   max-width: 600px;
   padding: 40px 24px;

   @media (max-width: 768px) {
      max-width: 100%;
      padding: 32px 20px;
   }
`

const LogoHeader = styled.div`
   margin-bottom: 36px;

   img {
      height: 36px;
   }
`

const FormContent = styled.div``

export default AuthContainer
